import { useRef } from "react";

// Guarda de alterações não salvas para diálogos de formulário.
// setBaseline(obj): registra o snapshot inicial (chame ao abrir/preencher o form).
// guard(onOpenChange, current): envolve o onOpenChange do Dialog; ao fechar (v=false)
// com alterações não salvas, pede confirmação antes de descartar.
export function useUnsavedGuard() {
  const initialRef = useRef("");
  const setBaseline = (obj) => { initialRef.current = JSON.stringify(obj); };
  const guard = (onOpenChange, current) => (v) => {
    if (!v && JSON.stringify(current) !== initialRef.current) {
      if (!window.confirm("Deseja sair sem salvar? As alterações não salvas serão perdidas.")) return;
    }
    onOpenChange(v);
  };
  return { setBaseline, guard };
}
